import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      // Bottom-right toasts would sit under the Shopify admin bottom overlay (Sidekick
      // bar); lift them by its height on top of sonner's default edge offsets.
      offset={{ bottom: 'calc(var(--shopify-safe-area-inset-bottom, 0px) + 32px)' }}
      mobileOffset={{ bottom: 'calc(var(--shopify-safe-area-inset-bottom, 0px) + 16px)' }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          error:
            'group-[.toaster]:!border group-[.toaster]:!border-solid group-[.toaster]:!border-destructive/30 group-[.toaster]:!text-destructive',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}
